import { storageGet, storageSet } from '@faceup/utils'

const CUSTOMIZE_CLIENT = 'CUSTOMIZE_CLIENT'

export type Clients = 'iframe' | 'jobka' | 'app'
const CLIENTS: Clients[] = ['jobka', 'iframe']

/**
 * Resolves an explicit `?client=jobka|iframe` override (persisted to
 * sessionStorage), independent of React. Shared by the ClientProvider and the
 * module-level Apollo JWT lookup so they agree on the client kind.
 */
export const resolveCustomizeClient = (search: string = window.location.search): Clients | null => {
  const client = new URLSearchParams(search).get('client')

  if (client && CLIENTS.includes(client as Clients)) {
    storageSet('sessionStorage', CUSTOMIZE_CLIENT, client)
    return client as Clients
  }
  return (storageGet('sessionStorage', CUSTOMIZE_CLIENT) as Clients) ?? null
}

const useCustomizationByURLParams = (search: string) => ({
  customizeClient: () => resolveCustomizeClient(search),
})

export default useCustomizationByURLParams
